// intent for using mouse
document.addEventListener("click", (): void => {
  if (!document.body.classList.contains("intent-mouse")) {
    document.body.classList.add("intent-mouse");
  }
});
document.addEventListener("keydown", (): void => {
  if (document.body.classList.contains("intent-mouse")) {
    document.body.classList.remove("intent-mouse");
  }
});

export {};
